"use client";

// 2026-09-02 Sentry error boundary — websearch 2026 Sentry capturing-errors: error.tsx must captureException (RouteErrorPage also does via reportClientError defense-in-depth)
// 2026-10-10 E4: `import * as Sentry` era estático y mantenía 274 KB del SDK
// browser en el first-load de las 38 rutas (chunks 0003w8-toalv0.js 232 KB +
// 0gir71xw27m--.js 42 KB, ver bundle-budget.test.ts HEAVY_JUSTIFIED). Con
// await import el SDK vive en su propio chunk y solo se baja cuando este
// boundary se renderiza; el try/catch garantiza que un fallo del import nunca
// pierde el error original ni tumba la página.
import { useEffect } from "react";
import { RouteErrorPage } from "@/components/shared/RouteErrorPage";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    void import("@sentry/nextjs")
      .then((Sentry) => {
        Sentry.captureException(error, { tags: { digest: error.digest } });
      })
      .catch((reportError) => {
        console.error("Sentry captureException failed", reportError, error);
      });
  }, [error]);

  return <RouteErrorPage error={error} reset={reset} showHomeLink showDigest />;
}
